
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnshipMinimisedSternlineIec as ObiOwnshipMinimisedSternlineIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ownship-minimised-sternline-iec.js';
 
 
 

 
 export const ObiOwnshipMinimisedSternlineIec = createComponent({
   react: React,
   tagName: 'obi-ownship-minimised-sternline-iec',
   elementClass: ObiOwnshipMinimisedSternlineIecElement,
   events: {
     
   }
  });
 
 